import React, { useMemo } from "react";
import { getAccuratePixels } from "../../utils/global";

function Usb({ isDownloadMode, downloadAs }) {
  const totalWidth = isDownloadMode ? 283 + "px" : getAccuratePixels(283);
  const totalHeight = isDownloadMode ? 596 + "px" : getAccuratePixels(596);

  const width = isDownloadMode ? 89 + "px" : getAccuratePixels(89);
  const height = isDownloadMode ? 171 + "px" : getAccuratePixels(171);

  const marginTop = isDownloadMode ? 167 + "px" : getAccuratePixels(167);

  const cerclewidth = isDownloadMode ? 30 + "px" : getAccuratePixels(30);
  const cercleHeight = isDownloadMode ? 30 + "px" : getAccuratePixels(30);
  const border = useMemo(() => {
    if (downloadAs == "cutout-png") {
      return "1px solid black";
    }

    if (downloadAs == "icon-png") {
      return null;
    }

    return "2px solid #6495ED";
  }, [downloadAs]);

  return (
    <div
      style={{
        width: totalWidth,
        height: totalHeight,
        display: "flex",
        flexDirection: "column",
        // justifyContent: "end",
        alignItems: "center",
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          gap: "5px",
          marginBlockStart: marginTop,
        }}
      >
        <div
          className="rounded-full"
          style={{
            border: border,
            width: cerclewidth,
            height: cercleHeight,
          }}
        ></div>
        <div
          style={{
            width: width,
            height: height,
            border: border,
          }}
        ></div>
      </div>
    </div>
  );
}

export default Usb;
